<p>{{ dataItem?.template?.name }}</p>
